import { Badge } from "@/components/ui/badge";
import { Card, CardBody, CardTitle } from "@/components/ui/card";
import { useSsoLocale, type SsoLocaleCatalog } from "@/i18n/use-sso-locale";

/**
 * The SSO surfaces that the admin contract declares but does not serve yet.
 * Providers, role mapping, enable/disable and break-glass all have served
 * routes now and are rendered by their own cards above; what is still
 * `x-alloy-status: planned` is the connection test (run a real sign-in against
 * a provider before routing live traffic to it). It stays a labelled gap with
 * no controls to click and no placeholder rows — a "coming next" note, not a
 * fake table.
 */
const ITEMS: { titleKey: string; descriptionKey: string }[] = [
  { titleKey: "sso.coming.testsTitle", descriptionKey: "sso.coming.testsDescription" },
];

export function AdminSsoComingNext({ catalog }: { catalog?: SsoLocaleCatalog }) {
  const fallback = useSsoLocale();
  const ui = (catalog ?? fallback).ui;

  return (
    <Card className="mt-5 border-dashed">
      <CardBody>
        <div className="flex flex-wrap items-center justify-between gap-2">
          <CardTitle>{ui["sso.coming.title"]}</CardTitle>
          <Badge variant="neutral" size="sm">
            {ui["sso.coming.badge"]}
          </Badge>
        </div>
        <p className="mt-2 max-w-[620px] text-xs leading-relaxed text-muted">
          {ui["sso.coming.description"]}
        </p>
        <ul className="mt-4 flex flex-col gap-3">
          {ITEMS.map((item) => (
            <li key={item.titleKey} className="rounded-md border border-line bg-bg px-3 py-2.5">
              <div className="text-xs font-bold text-ink">{ui[item.titleKey]}</div>
              <p className="mt-1 text-xs leading-relaxed text-muted">{ui[item.descriptionKey]}</p>
            </li>
          ))}
        </ul>
        <p className="mt-4 font-mono text-[10.5px] leading-relaxed text-muted">{ui["sso.coming.contract"]}</p>
      </CardBody>
    </Card>
  );
}
